import { answersToOptions } from "src/shared/utils/react-select";

export const DURATION_OPTIONS = answersToOptions([
  "5 minutes",
  "10 minutes",
  "15 minutes",
  "20 minutes",
  "25 minutes",
  "30 minutes",
]);
